(function (){
    'use strict';

    angular
        .module('services')
        .service('FindClientsService', FindClientsService);

    FindClientsService.$inject = ['$http', 'API_BASE'];

    function FindClientsService ($http, API_BASE) {
        var service = this;

        service.getAll                     = getAll;
        service.getExpo                    = getExpo;
        service.getExpoVirtual             = getExpoVirtual;
        service.getWebinars                = getWebinars;
        service.getGeneralInformation      = getGeneralInformation;
        service.getByFilter                = getByFilter;
        service.getByName                  = getByName;
        service.getByEmail                 = getByEmail;
        service.edit                       = edit;
        service.toggleApproved             = toggleApproved;
        service.getCountriesByExpo         = getCountriesByExpo;
        service.getAddresses               = getAddresses;
        service.blacklist                  = blacklist;


        function getAll () {
            return $http.get(API_BASE + '/edufindme/list');
        }

        function getExpo (id, type) {
            return $http.get(API_BASE + '/edufindme/expo/findclients/'+type+'/'+ id);
        }

        function getExpoVirtual (id, type) {
            return $http.get(API_BASE + '/edufindme/expovirtual/findclients/'+type+'/'+ id);
        }

        function getWebinars (id, type) {
            return $http.get(API_BASE + '/edufindme/webinars/findclients/'+type+'/'+ id);
        }

        function getGeneralInformation (id, type) {
            return $http.get(API_BASE + '/edufindme/generalinformation/findclients/'+type+'/'+ id);
        }

        function getByName (name) {
            return $http.get(API_BASE + '/edufindme/find/name/'+ name);
        }

        function getByEmail (email) {
            return $http.get(API_BASE + '/edufindme/find/email/'+ email);
        }

        function getAddresses (id) {
            return $http.get(API_BASE + '/edufindme/user/'+ id + '/addresses');
        }

        function edit (client) {
            return $http.get(API_BASE + '/edufindme/edit/account',{
                params: {
                    data: client
                }
            });
        }

        function toggleApproved (request) {
            return $http.get(API_BASE + '/edufindme/approved',{params:request});
        }

        function getByFilter (fields, page) {
            return $http.post(API_BASE + '/edufindme/filter', fields, {header:{'Content-Type':'application/json; charset=ISO-8859-1'}});
        }

        function getCountriesByExpo (expo_id, type) {
            return $http.get(API_BASE + '/'+type+'/countries/list',{params:{expo_id:expo_id}});
        }

        function blacklist (fields) {
            return $http.post(API_BASE + '/edufindme/blacklist', fields, {header:{'Content-Type':'application/json; charset=ISO-8859-1'}});
        }

    }
})();